import React from "react";
import Window from "../windows/Window";
import Input from "../ui/Input";
import { Comm } from "../core/comm/Comm";

import "./Gifs.css";

export default class Gifs extends React.Component<Gifs.Props, Gifs.State>
{

    ref: React.RefObject<HTMLInputElement>;
    searchTimeout: ReturnType<typeof setTimeout>;

    defaultGifs: Array<Gifs.GifData>;

    constructor(props: Gifs.Props)
    {
        super(props);

        this.ref = React.createRef();

        this.state = {
            gifs: null,
            loading: true
        };
    }


    componentDidMount()
    {
        Comm.on(Comm.RESPONSE.GIFS, this.onData, this);

        Comm.send(Comm.REQUEST.GIFS, {query: null});
    }


    componentWillUnmount()
    {
        Comm.off(Comm.RESPONSE.GIFS, this.onData, this);
    }


    onData(data: Comm.ResponseTypes.Gifs)
    {
        if (!this.defaultGifs)
        {
            this.defaultGifs = data.gifs;
        }

        this.setState({
            gifs: data.gifs,
            loading: false
        });
    }


    onInput()
    {
        if (this.ref.current.value == "")
        {
            this.setState({
                gifs: this.defaultGifs,
                loading: false
            });
        }
        else
        {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(this.search.bind(this), 1000);
        }
    }


    search()
    {
        this.setState({
            loading: true
        });

        Comm.send(Comm.REQUEST.GIFS, {
            query: this.ref.current.value
        });
    }


    render()
    {
        const title = window.lang.shared.gif; 
        const lang = window.lang.game["chat-widget"]["chat-input"]["chat-input-tools"]["chat-input-tool-gif"];
        
        return (
            <Window
                id="gifs"
                title={title}
                close={this.props.close}
            >

                <div className="input">
                    <Input 
                        placeholder={lang["search gif"]}
                        onInput={this.onInput.bind(this)}
                        refinput={this.ref}
                    />
                </div>

                <div className="content scroll-y">
                    {this.renderGifs()}
                </div>
            </Window>
        );
    }


    renderGifs()
    {
        if (this.state.loading)
        {
            return <div className="loader"></div>;
        }

        const arr = this.state.gifs.map(data => (
            <div className="gifContainer">
                <div
                    className="gif"
                    style={{
                        background: "url(" + data.preview + ") center center / cover"
                    }}
                    onClick={this.props.onSelect.bind(null, data.url)}
                ></div>
            </div>
        ));

        console.log(arr);

        return arr;
    }


}

export namespace Gifs
{

    export interface GifData
    {
        url: string;
        preview: string;
    }

    export interface Props
    {
        onSelect: (url: string) => void;
        close: () => void;
    }

    export interface State
    {
        gifs: Array<GifData>;
        loading: boolean;
    }

}